import { currenciesDa } from './da';
import { currenciesEn } from './en';
import { currenciesFo } from './fo';
import { currenciesNo } from './no';

export const languageToCurrencies: Record<string, Record<string, string>> = {
  da: currenciesDa,
  en: currenciesEn,
  fo: currenciesFo,
  no: currenciesNo,
} as const;
